import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="text-lg font-bold text-background-50">海角社区视频</span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                发现精彩内容，畅享社区视频乐趣。海角社区视频汇聚海量优质内容，让每一位用户都能找到属于自己的精彩。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="B站">
                  <i className="ri-bilibili-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="抖音">
                  <i className="ri-tiktok-line text-background-50 text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {categories.filter(c => c.id !== 'all').slice(0, 6).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快捷导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">首页</Link></li>
                <li><Link to="/category/entertainment" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">娱乐搞笑</Link></li>
                <li><Link to="/category/food" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">美食烹饪</Link></li>
                <li><Link to="/category/travel" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">旅行户外</Link></li>
                <li><Link to="/category/tech" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">科技数码</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-foreground-400 mt-0.5 text-sm"></i>
                  <span className="text-sm text-foreground-300">contact@haijiaoshipin.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-foreground-400 mt-0.5 text-sm"></i>
                  <span className="text-sm text-foreground-300">400-888-6666</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-foreground-400 mt-0.5 text-sm"></i>
                  <span className="text-sm text-foreground-300">北京市朝阳区望京科技园A座15层</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2026 海角社区视频 版权所有 | 京ICP备2024000000号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">社区规范</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}